

<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>
<div class="container">
    <div class="row">
        <div class="col-12 text-center">
            <mat-tab-group>
                <mat-tab label="Manage schedule">
                   
                        <mat-tab-group  *ngIf="schedule && days">
                            <div *ngFor = "let da of days" >
                                    <mat-tab label="{{da}}" style="background-color:#dbd3be">
                                            <table  id="pctab"   class="table table-bordered" style="margin-top:10px"
                                            *ngIf="getSchedulelength(da)>0" >
                                                    <tr class="card-header">
                                                       <th>Start Time</th>
                                                       <th>End Time</th>
                                                       <th>Slot Duration</th>
                                                       <th>Clinic</th>
                                                       <th>Manage</th>
                                                    </tr>
                                                       <tbody *ngFor="let s of schedule">
                                                                <tr  *ngIf="s.day == da">
                                                                        <td  >{{s.start_time}}</td>
                                                                        <td> {{s.end_time}}</td>
                                                                        <td >{{s.slotduration}}</td>
                                                                        <td *ngIf="myregisterclinic">
                                                                            <div *ngFor="let c of myregisterclinic">
                                                                                <div *ngIf="c.id == s.clinic_id">
                                                                                    <p>{{c.name}}</p>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                         <td>
                                                                       <div class="tg-btnaction" >
                                                                         <a class="tg-btnview" (click)="editSchedule(s.id,s.day,s.start_time,s.end_time,s.slotduration)"><i class="fa fa-check"></i></a>
                                                                         <a class="tg-btndelete" style="color:#fff,!important"
                                                                         (click)="deleteschedule(s.id)" ><i class="fa fa-minus"></i></a>
                                                                     </div>
                                                                 </td>
                                                               </tr>
                                               </tbody>
                                            </table>
                                                 
                                            <mat-card *ngIf="getSchedulelength(da) > 0">
                                                    <mat-card-content>
                                                        <div class="row">
                                                            <div class="col-12" text-center >
                                                                <button  class="btn btn-success btn-block" (click)="addSchedule(da)" >
                                                                    Add Another Schedule For {{da}} </button> 
                                                            </div>
                                                          </div>
                                                    </mat-card-content>
                                                  </mat-card>

                                            <mat-card *ngIf="getSchedulelength(da) == 0">
                                                    <mat-card-content>
                                                        <div class="row">
                                                            <div class="col-12" text-center >
                                                                <label style="color: #cb983f;font-size: 18px "> 
                                                                    No Schedule Found  </label>   
                                                            </div>
                                                            <div class="col-12" text-center >
                                                                <button  class="btn btn-success btn-block" (click)="addSchedule(da)" >
                                                                    Add Schedule </button> 
                                                            </div>
                                                          </div>
                                                    </mat-card-content>
                                                  </mat-card>
                                    </mat-tab>  
                            </div>   
                           
                        </mat-tab-group>
                </mat-tab>
                <mat-tab label="Leave">
                    <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6" style="margin-top:10px">
                            <div class="row">
                                <div class="col-12">
                                <div class='flex-container flex-center' style="cursor: pointer" >
                                        <div id='calendar-container' class='flex-container flex-column'>
                                                <div class=' flex-container flex-center-horz '>
                                                  <div class="card-header" style="width:100%; height:50px; background-color:#9b7544">
                                                    <div class="row">
                                                      <div class="col-4 text-left">
                                                          <div  style="color:#fff" (click)='previousMonth() '><<</div>
                                                      </div>
                                                      <div class="col-4 text-center">
                                                          <div style="font-family:open sans;  color: #fff">{{date.format('MMMM ')}} {{date.format('YYYY ')}}</div>
                                                        </div>
                                                        <div class="col-4 text-right">
                                                            <div style="color:#fff" (click)='nextMonth() '>>></div>
                                                          </div>
                                                    </div>
                                                  </div>
                                                </div>
                                            <div class='height-20px '></div>
                                            <div class='flex-container '>
                                                <div class='calendar-days4 flex-container flex-center '>S</div>
                                                <div class='calendar-days4 flex-container flex-center '>M</div>
                                                <div class='calendar-days4 flex-container flex-center '>T</div>
                                                <div class='calendar-days4 flex-container flex-center '>W</div>
                                                <div class='calendar-days4 flex-container flex-center '>T</div>
                                                <div class='calendar-days4 flex-container flex-center '>F</div>
                                                <div class='calendar-days4 flex-container flex-center '>S</div>

                                            </div>
                                            <div class='flex-container flex-wrap ' *ngIf="lsstatus>0 && daysArr">
                                                    <div *ngFor="let day of daysArr">
                                                        <div class='calendar-days flex-container flex-center ' (click)='selectedDate(day)' [ngClass]="{'inactive ': !day, 'selected': isSelected(day), 'today': todayCheck(day), 'leave':  leavedaysCheck(day)}">{{day?.date()}}</div>
                                                    </div>
                                                </div>
                                                <div class='flex-container flex-wrap ' *ngIf="lsstatus==0">
                                                        <div *ngFor="let day of daysArr">
                                                            <div class='calendar-days flex-container flex-center ' (click)='selectedDate(day)' [ngClass]="{'inactive ': !day, 'selected': isSelected(day), 'today': todayCheck(day)}">{{day?.date()}}</div>
                                                        </div>
                                                    </div>
                                        </div>
                                    </div>
                                </div>
                             </div>
                             <div class="row" style="margin-top:10px">
                                    <div class="col-sm-6 col-md-6 col-lg-3 col-xl-3">
                                           <td  style="float: right" class="calendar-days1 flex-container flex-center"></td>
                                    </div>
                                    <div class="col-sm-6 col-md-6 col-lg-3 col-xl-3">
                                           <td>Leave Days</td>
                                       </div>
                                       <div class="col-sm-6 col-md-6 col-lg-3 col-xl-3">
                                               <td style="float: right" class="calendar-days2 flex-container flex-center"></td>
                                   </div>
                                   <div class="col-sm-6 col-md-6 col-lg-3 col-xl-3">
                                           <td>Selected Days</td>
                               </div>
                                </div>
                       </div>
                        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-center" style="margin-top:10px">
                         <div class="row">
                             <div class="col-12 text-center">
                                      <div  style=" color:#9b7544;" *ngIf="sdays && sdays.length > 0">
                                      <h4> Selected Days For leave</h4>
                                    </div>
                             </div>
                        </div>
                        <div class="row" style="margin-top:10px" *ngIf="sdays && sdays.length>0">
                        <div class="col-12" >
                                <div class='flex-container flex-center'>
                                        <div  id='calendar-container' class='flex-container flex-column'>
                                              <div class='flex-container flex-wrap '>
                                          <div  *ngFor="let day of sdays">
                                             <div class='calendar-days flex-container flex-center ' > {{day}}</div>
                                         </div>
                                         </div>
                                       </div>
                                      </div>

                                    
                        </div>
                        
                        <div class="col-12"text-center>
                           
                                   
                            <p class="text-center">Your Registered Clinic(s)</p>
                            <form  #f1="ngForm">
                           <div class="row" *ngFor="let c of myregisterclinic">
                                <span style="font-weight:normal; display: inline-flex;" *ngIf="!(checkallhit == 'all')">
                                <input style="display: block !important; margin: 5px;" type="checkbox" name="clinic" [(ngModel)]="c.cecked" [value] = "c.id"  (change)="addClicnicid($event,c.id)">
                                {{c.name}} 
                                </span>
                           </div>
                          
                        </form>
                        <span style="font-weight:normal; display: inline-flex;" *ngIf="checkarray.length == 0">
                            <input style="display: block !important; margin: 5px;" type="checkbox" name="all" ngModel="{{isAllChecked()}}"  (change)="setCheckhit($event)">
                            Mark leave for all clinics
                            </span>
                        </div>
                        <div class="col-12 text-center" style="margin-top:10px" >
                            <button class="btn btn-success btn-block " (click)='checkSelction()'>
                                Confirm
                            </button>
                        </div>


                        </div>
                        </div>
                     </div>
                     <div class="row" style="margin-top:15px">
                         <div class="col-12">
                            <div class="card-header text-center" style="background:#9b7544;color:#fff">
                                <h5>LeaveDays In {{date.format('MMMM ')}} </h5>
                               </div>
                         </div>
                     </div>
                     <div class="row">
                         <div class="col-6 text-center">
                                <table id="pctab"  class="table table-bordered" style="text-align: center;border-color:#cb983f,2px,solid;
                                margin-top:4px" *ngIf="ldaysarray.length > 0 ; else noleave">
                                        <tr class="card-header">
                                            <th>Date</th>
                                            <th>Action</th>
                                           </tr>
                                           <tbody>

                                                <tr *ngFor="let s of ldaysarray">
                                                <td>{{s.day}}</td>
                                                <td > 
                                                        <button  class="btn btn-link btn-sm" style="color:#9b7544" (click)="exploreLeave(s.id,s.day)">View</button>
                                                <button *ngIf="s.day > today" class="btn btn-link btn-sm" style="color:red"
                                                     (click)='cancellLeave(s.id,s.day)'>
                                                        Cancel</button>
                                                </td>
                                                </tr>
                                </tbody>
                                </table>
                         </div>
                         <div class="col-1"></div>
                         <div class="col-5 text-center" *ngIf="exploreleavedate && leavemap.length>0" >
                                 <table  class="table table-bordered" style="text-align: center;border:#cb983f 2px solid;
                                margin-top:4px" >
                                        <tr class="card-header" style="border:#cb983f 2px solid">
                                            <th>Clinic Leave Status on {{exploreleavedate}}</th>
                                            <th>Status</th>
                                           </tr>
                                           <tbody >

                                                <tr  *ngFor="let c of myregisterclinic" style="border:#cb983f 2px solid">
                                                <td>{{c.name}}</td>
                                                <td>
                                             <span style="font-weight:normal; display: inline-flex;" *ngIf="isLeaveMapped(c.id)">
                                                <input style="display: block !important; margin: 5px;" 
                                                type="checkbox" name="che" ngModel="{{isLeaveMapped(c.id)}}" [value] = "c.id"  
                                                disabled>Yes
                                                </span>  
                                                
                                                <span style="font-weight:normal; display: inline-flex;" *ngIf="!(isLeaveMapped(c.id))">
                                                        <input style="display: block !important; margin: 5px;" 
                                                        type="checkbox" name="che" ngModel="{{isLeaveMapped(c.id)}}" [value] = "c.id"  
                                                        disabled>No
                                                        </span> 
                                                </td>
                                                </tr>
                                </tbody>
                                </table>
                         </div>
                     </div>

                     </mat-tab>
                     </mat-tab-group>
                     </div>
                     </div>

</div>

<ng-template #noleave>
<div class="row">
    <div class="col-12 text-center">
        <h6><p style="font-style:open sans;color:#9b7544; overflow-wrap:break-word">
          No Leave
        </p></h6>
    </div>
</div>
</ng-template>
